import httpClient from "../Core/http";

class RunTime_Api {
  getCustomerGatewayInfo(params: any, signal: any): Promise<any> {
    let url = "machine/runTimes";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params, signal: signal })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
}

export const RuntimeApi = new RunTime_Api();
